<div class="p-10">
  <form nz-form nz-row [formGroup]="adjustVoidPurchaseForm" class="ppl-p0 mt-2">

    @if (actionType === 'adjustPurchase') {
      <div class="table-scroll-wrapper">
        <table class="purchase-adjust-table">
          <thead>
            <tr>
              <th style="background-color: #a8e4e14d; width: 6%;"></th>
              <th style="background-color: #a8e4e14d; width: 11%;">
                Service<br>Code <span class="required-marker">*</span>
              </th>
              <th style="background-color: #a8e4e14d; width: 13%;">
                Service<br>Description <span class="required-marker">*</span>
              </th>
              <th style="background-color: #a8e4e14d; width: 12%;">
                PPL Authorization<br>Number
              </th>
              <th style="background-color: #a8e4e14d; width: 12%;">
                Regional<br>Center
              </th>
              <th style="background-color: #a8e4e14d; width: 7%;">
                Units <span class="required-marker">*</span>
              </th>
              <th style="background-color: #a8e4e14d; width: 8%;">
                Price <span class="required-marker">*</span>
              </th>
              <th style="background-color: #a8e4e14d; width: 8%;">
                Tax<br>Amount <span class="required-marker">*</span>
              </th>
              <th style="background-color: #a8e4e14d; width: 9%;">
                Shipping<br>Amount <span class="required-marker">*</span>
              </th>
              <th style="background-color: #a8e4e14d; width: 9%;">
                CRM<br>Number <span class="required-marker">*</span>
              </th>
              <th style="background-color: #a8e4e14d; width: 12%;">
                Adjust<br>Reason <span class="required-marker">*</span>
              </th>
              <th style="background-color: #a8e4e14d; width: 12%;">
                Reason<br>Details
                @if(adjustVoidPurchaseForm.get('reason')?.value?.lkpValueName?.toLowerCase()?.startsWith('other')) {
                  <span class="required-marker">*</span>
                }
              </th>
            </tr>
          </thead>

          <tbody>
            <!-- INPUT ROW -->
            <tr>
              <td><b>New values</b></td>
              <td>
                <nz-select formControlName="serviceCode" class="filters" id="serviceCode" nzPlaceHolder="Service Code"
                  nzShowSearch nzAllowClear
                  (ngModelChange)="onServiceCodeChange($event)"
                  [nzStatus]="adjustVoidPurchaseForm.get('serviceCode')?.invalid && adjustVoidPurchaseForm.get('serviceCode')?.touched ? 'error' : ''">
                  @for (opt of serviceCodesData; track $index) {
                    <nz-option [nzLabel]="opt.serviceCodeDetail" [nzValue]="opt.serviceCodeDetailId"></nz-option>
                  }
                </nz-select>
              </td>
              <td>
                <nz-select formControlName="serviceDescription" class="filters" id="serviceDescription"
                  nzPlaceHolder="Service Description" nzShowSearch nzAllowClear
                  (ngModelChange)="onServiceDescriptionChange($event)"
                  [nzStatus]="adjustVoidPurchaseForm.get('serviceDescription')?.invalid && adjustVoidPurchaseForm.get('serviceDescription')?.touched ? 'error' : ''">
                  @for (opt of serviceDescriptions; track $index) {
                    <nz-option [nzLabel]="opt.desc" [nzValue]="opt.ids"></nz-option>
                  }
                </nz-select>
              </td>
              <td>
                <span class="previous-value" id="pplAuthNum">{{ selectedPplAuthNum }}</span>
              </td>
              <td>
                <span class="previous-value" id="regionalCenter">{{ selectedRegionalCenter }}</span>
              </td>
              <td>
                <input nz-input type="number" formControlName="unit" placeholder="Units"
                  [class.ant-input-status-error]="adjustVoidPurchaseForm.get('unit')?.invalid && adjustVoidPurchaseForm.get('unit')?.touched" />
              </td>
              <td>
                <input nz-input type="number" formControlName="price" placeholder="Price"
                  [class.ant-input-status-error]="adjustVoidPurchaseForm.get('price')?.invalid && adjustVoidPurchaseForm.get('price')?.touched" />
              </td>
              <td>
                <input nz-input type="number" formControlName="taxAmount" placeholder="Tax Amount"
                  [class.ant-input-status-error]="adjustVoidPurchaseForm.get('taxAmount')?.invalid && adjustVoidPurchaseForm.get('taxAmount')?.touched" />
              </td>
              <td>
                <input nz-input type="number" formControlName="shippingAmount" placeholder="Shipping Amount"
                  [class.ant-input-status-error]="adjustVoidPurchaseForm.get('shippingAmount')?.invalid && adjustVoidPurchaseForm.get('shippingAmount')?.touched" />
              </td>
              <td>
                <input nz-input formControlName="crmNumber" placeholder="CRM Number" maxlength="50"
                  [class.ant-input-status-error]="adjustVoidPurchaseForm.get('crmNumber')?.invalid && adjustVoidPurchaseForm.get('crmNumber')?.touched" />
              </td>
              <td>
                <nz-select formControlName="reason" class="filters" id="reason" nzPlaceHolder="Select Reason"
                  nzShowSearch nzAllowClear
                  [nzStatus]="adjustVoidPurchaseForm.get('reason')?.invalid && adjustVoidPurchaseForm.get('reason')?.touched ? 'error' : ''">
                  <nz-option *ngFor="let opt of reasonList" [nzLabel]="opt.lkpValueName" [nzValue]="opt"></nz-option>
                </nz-select>
              </td>
              <td>
                <input nz-input formControlName="reasonDetails" placeholder="Enter reason details" maxlength="160"
                  [class.ant-input-status-error]="adjustVoidPurchaseForm.get('reasonDetails')?.invalid && adjustVoidPurchaseForm.get('reasonDetails')?.touched" />
              </td>
            </tr>

            <!-- ERROR ROW -->
            <tr>
              <td></td>
              <td>
                <div class="error-message">
                  @if (adjustVoidPurchaseForm.get('serviceCode')?.invalid && adjustVoidPurchaseForm.get('serviceCode')?.touched) {
                    Please select the service code
                  }
                </div>
              </td>
              <td>
                <div class="error-message">
                  @if (adjustVoidPurchaseForm.get('serviceDescription')?.invalid && adjustVoidPurchaseForm.get('serviceDescription')?.touched) {
                    Please select the service description
                  }
                </div>
              </td>
              <td></td>
              <td></td>
              <td>
                <div class="error-message">
                  @if (adjustVoidPurchaseForm.get('unit')?.invalid && adjustVoidPurchaseForm.get('unit')?.touched) {
                    Please enter units
                  }
                </div>
              </td>
              <td>
                <div class="error-message">
                  @if (adjustVoidPurchaseForm.get('price')?.invalid && adjustVoidPurchaseForm.get('price')?.touched) {
                    Please enter price
                  }
                </div>
              </td>
              <td>
                <div class="error-message">
                  @if (adjustVoidPurchaseForm.get('taxAmount')?.invalid && adjustVoidPurchaseForm.get('taxAmount')?.touched) {
                    Please enter tax amount
                  }
                </div>
              </td>
              <td>
                <div class="error-message">
                  @if (adjustVoidPurchaseForm.get('shippingAmount')?.invalid && adjustVoidPurchaseForm.get('shippingAmount')?.touched) {
                    Please enter shipping amount
                  }
                </div>
              </td>
              <td>
                <div class="error-message">
                  @if (adjustVoidPurchaseForm.get('crmNumber')?.invalid && adjustVoidPurchaseForm.get('crmNumber')?.touched) {
                    Please enter the CRM Number
                  }
                </div>
              </td>
              <td>
                <div class="error-message">
                  @if (adjustVoidPurchaseForm.get('reason')?.invalid && adjustVoidPurchaseForm.get('reason')?.touched) {
                    Please select the reason
                  }
                </div>
              </td>
              <td>
                <div class="error-message">
                  @if (adjustVoidPurchaseForm.get('reasonDetails')?.invalid && adjustVoidPurchaseForm.get('reasonDetails')?.touched) {
                    Please enter the reason details
                  }
                </div>
              </td>
            </tr>

            <!-- PREVIOUS VALUES ROW -->
            <tr>
              <td><b>Previous values</b></td>
              <td><span class="previous-value">{{ purchaseData?.serviceCodeLabel }}</span></td>
              <td><span class="previous-value">{{ purchaseData?.authDesc }}</span></td>
              <td></td>
              <td></td>
              <td><span class="previous-value">{{ purchaseData?.unit }}</span></td>
              <td><span class="previous-value">{{ purchaseData?.price }}</span></td>
              <td><span class="previous-value">{{ purchaseData?.taxAmount }}</span></td>
              <td><span class="previous-value">{{ purchaseData?.shippingAmount }}</span></td>
              <td><span class="previous-value">{{ purchaseData?.crmNumber }}</span></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    } @else {
      <table class="table">
        <thead>
          <tr>
            @if (actionType === 'voidPurchase') {
              <th style="background-color: #a8e4e14d; width: 10%;">Tax Amount</th>
              <th style="background-color: #a8e4e14d; width: 10%;">Shipping Amount</th>
            }
            <th style="background-color: #a8e4e14d; width: 12%; white-space: pre-line;">Void Reason <span class="required-marker">*</span></th>
            <th style="background-color: #a8e4e14d; width: 12%;">Reason Details @if(adjustVoidPurchaseForm.get('reason')?.value?.lkpValueName?.toLowerCase()?.startsWith('other')) {<span class="required-marker">*</span>}</th>
            <th style="background-color: #a8e4e14d; width: 12%;">CRM Number <span class="required-marker">*</span></th>
          </tr>
        </thead>

        <tbody>
          <tr>
            @if (actionType === 'voidPurchase') {
              <td>
                <input nz-input type="number" formControlName="taxAmount" placeholder="Tax Amount" style="width: 100%;" />
              </td>
              <td>
                <input nz-input type="number" formControlName="shippingAmount" placeholder="Shipping Amount" style="width: 100%;" />
              </td>
            }
            <td>
              <nz-select formControlName="reason" class="filters" id="reason" nzPlaceHolder="Select Reason"
                nzShowSearch nzAllowClear style="width: 100%;"
                [nzStatus]="adjustVoidPurchaseForm.get('reason')?.invalid && adjustVoidPurchaseForm.get('reason')?.touched ? 'error' : ''">
                <nz-option *ngFor="let opt of reasonList" [nzLabel]="opt.lkpValueName" [nzValue]="opt"></nz-option>
              </nz-select>
            </td>
            <td>
              <input nz-input formControlName="reasonDetails" placeholder="Enter reason details"
                maxlength="160" style="width: 100%;"
                [class.ant-input-status-error]="adjustVoidPurchaseForm.get('reasonDetails')?.invalid && adjustVoidPurchaseForm.get('reasonDetails')?.touched" />
            </td>
            <td>
              <input nz-input formControlName="crmNumber" placeholder="CRM Number" maxlength="50" style="width: 100%;"
                [class.ant-input-status-error]="adjustVoidPurchaseForm.get('crmNumber')?.invalid && adjustVoidPurchaseForm.get('crmNumber')?.touched" />
            </td>
          </tr>
          <tr>
            @if (actionType === 'voidPurchase') {
              <td></td>
              <td></td>
            }
            <td><div class="error-message">@if(adjustVoidPurchaseForm.get('reason')?.invalid && adjustVoidPurchaseForm.get('reason')?.touched) {Please select the reason}</div></td>
            <td><div class="error-message">@if(adjustVoidPurchaseForm.get('reasonDetails')?.invalid && adjustVoidPurchaseForm.get('reasonDetails')?.touched) {Please enter the reason details}</div></td>
            <td><div class="error-message">@if(adjustVoidPurchaseForm.get('crmNumber')?.invalid && adjustVoidPurchaseForm.get('crmNumber')?.touched) {Please enter the CRM Number}</div></td>
          </tr>
        </tbody>
      </table>
    }

    @if(hasPurchaseAdjustError) {
      <div class="w-100 alert alert-danger d-flex justify-content-between align-items-center">
        <span>{{ purchaseAdjustErrorMessage }}</span>
      </div>
    }

    <!-- Save button -->
    <div class="custom-row w-100 save-row">
      <ppl-button (click)="onSave()" [styleString]="'margin-right: 8px;'" label="{{ buttonLabel }}"
        icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'">
      </ppl-button>
    </div>

  </form>
</div>
